import React from 'react';
import { Div, Ul, Li } from '../element';

export const VerticalWizard = ({ steps, element, queryString, category }) => {
  return (
    <Div className="wizard vertical">
      <Ul className="stepper stepper-vertical">
        {steps
          .filter(item => item.menuText)
          .map((item, index) => {
            return (
              <Li className={`${item.status}`} key={`stepContainer${index}`}>
                {React.cloneElement(element, {
                  ...item,
                  queryString,
                  testId: `sidebar-${category}-${item.menuText}-link`,
                })}
              </Li>
            );
          })}
      </Ul>
    </Div>
  );
};
